<template>
  <div class="product-content-wrapper">
    <div class="product-content-title">
      <img src="../../assets/mikmak-logo-new.png" alt="MikMak">
      <label>{{ product.name }}</label>
      <span class="patent-pending" v-if="product.patentPending">patent pending</span>
    </div>

    <div class="product-content-desc" v-html="product.description"></div>

    <div class="product-content-bullets" v-if="product.bullets.length > 0">
      <span v-for="bullet in product.bullets" v-html="bullet"></span>
    </div>

    <span class="product-cta">
      <a href="#contact-footer" v-on:click="logProductClick(product)">{{ product.cta }}</a>
    </span>
  </div>
</template>

<script>

import eventDispatcher from '../../events/dispatch'

export default {
  props: ['product'],
  mounted() {},
  methods: {
    logProductClick(product) {
      eventDispatcher('requestDemoClicked', {
        product: product.slug
      })
      this.addProductInterest(product)
      this.resetScroll()
    },
    resetScroll() {
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    },
    addProductInterest(product) {
      if (!window.mmProductInterests) window.mmProductInterests = []
      window.mmProductInterests.push(product.name)
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>
  .product-content-title img {
    width: 72px;
    margin-bottom: -2px;
  }

  .product-content-title label {
    font-family: 'Work Sans', sans-serif;
    color: #00BFBD;
    font-size: 32px;
    text-transform: uppercase;
    font-weight: lighter;
    letter-spacing: 4px;
    margin-left: 4px;
  }

  .product-content-detail-left .product-content-desc,
  .product-content-detail-left .product-content-title {
    text-align: left;
    width: 100%;
  }

  .product-content-detail-right .product-content-desc,
  .product-content-detail-right .product-content-title {
    text-align: right;
    width: 100%;
  }

  .product-content-desc {
    font-family: 'Work Sans', sans-serif;
    font-size: 22px;
    width: 100%;
    margin: 12px auto;
    color: #333;
  }

  .product-content-bullets span {
    font-family: 'Work Sans', sans-serif;
    display: block;
    font-size: 16px;
    padding: 0px 8px;
    margin: 24px auto;
    color: rgba(51, 51, 51, 0.49);
  }

  @media only screen and (max-width: 800px) {
    .product-content-bullets span {
      margin: 12px auto;
    }
  }

  @media only screen and (max-width: 550px) {
    .product-content-bullets span {
      margin: 12px auto;
    }
  }

  .product-content-detail-left .product-content-bullets span {
    text-align: left;
    border-left: 4px solid rgba(0, 0, 0, 0.02);
  }

  .product-content-detail-right .product-content-bullets span {
    text-align: right;
    border-right: 4px solid rgba(0, 0, 0, 0.02);
  }

  .product-cta {
    display: block;
  }

  .product-cta a {
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    display: block;
    text-decoration: none;
    color: white;
    background: #00BFBD;
    width: 100%;
    margin: 48px auto;
    border-radius: 100px;
    font-size: 18px;
    padding: 8px 0;
    font-weight: lighter;
  }

  .patent-pending {
    display: block;
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    font-size: 12px;
    background: rgb(0, 191, 189);
    width: 117px;
    text-align: center;
    border-radius: 2px;
    padding: 2px 4px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// ProductDetails.vue?2f838aca